// src/pages/About.tsx
import React from 'react';
import { Typography } from '@mui/material';

const About: React.FC = () => (
  <div style={{ padding: 20 }}>
    <Typography variant="h4" gutterBottom>
      About Page
    </Typography>
    <Typography variant="body1">
      This is the about page of the application. Here you can add information about your application or your team.
    </Typography>
  </div>
);

export default About;
